import { gql } from '@apollo/client';

export const CHAT_WITH_RAG = gql`
  mutation ChatWithRAG($params: ChatWithRAGInput!) {
    chatWithRAG(params: $params) {
      success
      message
      errors
      data {
        id
        chatId
        tenantId
        userId
        role
        content
        feedback
        createdAt
        createdBy
      }
    }
  }
`;

export const DELETE_CHAT = gql`
  mutation DeleteChatbotChat($params: DeleteChatbotChatInput!) {
    deleteChatbotChat(params: $params) {
      success
      message
      errors
    }
  }
`;
